import React from "react";
import { Box } from "arkh";

export function WorkspaceTodoStoresItemContainer(props: {
  storeName: React.ReactNode;
  completedAt: React.ReactNode;
  status: React.ReactNode;
  comments: React.ReactNode;
  response?: React.ReactNode;
}) {
  return (
    <Box style={{ flexDirection: "row", flex: 1, alignItems: "center" }}>
      <Box style={{ flex: 1, flexDirection: "row", alignItems: "center" }}>
        <Box style={{ width: "70%" }}>{props.storeName}</Box>
        <Box style={{ width: "30%" }}>{props.completedAt}</Box>
      </Box>
      <Box
        style={{
          width: 110,
        }}
      >
        {props.comments}
      </Box>

      {props.response ? (
        <Box style={{ width: 140, justifyContent: "flex-start" }}>
          {props.response}
        </Box>
      ) : null}

      <Box style={{ width: 110, justifyContent: "flex-end" }}>
        {props.status}
      </Box>
    </Box>
  );
}
